import React, { useEffect, useState } from "react";
import { MessageCircle, X, Phone, Send } from "lucide-react";
import { useLang } from "../i18n/LangContext";

const FloatingContact = ({ onOpenForm }) => {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;
  return (
    <div className="fixed right-5 z-40 flex flex-col items-end gap-3 bottom-24 md:bottom-5">
      {open && (
        <div className="bg-white rounded-2xl p-4 w-72 text-slate-900 shadow-2xl border border-slate-200 animate-in fade-in slide-in-from-bottom-3 duration-200">
          <div className="font-display text-lg uppercase mb-1">{t("contact.title")}</div>
          <div className="text-xs text-slate-500 mb-4">{t("contact.subtitle")}</div>
          <div className="space-y-2">
            <button onClick={() => { onOpenForm(); setOpen(false); }} className="w-full text-left px-3 py-2.5 rounded-xl bg-slate-50 hover:bg-amber-50 transition text-sm font-semibold flex items-center gap-2"><Send className="w-4 h-4 text-amber-600" /> {t("cta.leaveRequest")}</button>
            <a href="tel:+380673461626" className="w-full text-left px-3 py-2.5 rounded-xl bg-slate-50 hover:bg-amber-50 transition text-sm font-semibold flex items-center gap-2" data-testid="floating-call-1"><Phone className="w-4 h-4 text-amber-600" /> +38 067 346 16 26</a>
            <a href="tel:+380504429555" className="w-full text-left px-3 py-2.5 rounded-xl bg-slate-50 hover:bg-amber-50 transition text-sm font-semibold flex items-center gap-2" data-testid="floating-call-2"><Phone className="w-4 h-4 text-amber-600" /> +38 050 442 95 55</a>
            <a href="https://wa.me/31638633238" target="_blank" rel="noreferrer" className="w-full text-left px-3 py-2.5 rounded-xl bg-emerald-500 hover:bg-emerald-600 text-white transition text-sm font-semibold flex items-center gap-2" data-testid="floating-whatsapp"><MessageCircle className="w-4 h-4" /> WhatsApp +31 638 633 238</a>
          </div>
        </div>
      )}
      <button onClick={() => setOpen(!open)} className="relative w-14 h-14 rounded-full bg-amber-500 hover:bg-amber-600 text-white shadow-2xl shadow-amber-500/40 flex items-center justify-center transition" aria-label="contact">
        {!open && <span className="absolute inset-0 rounded-full bg-amber-500/50 animate-ping" />}
        {open ? <X className="w-6 h-6 relative" /> : <Phone className="w-6 h-6 relative" />}
      </button>
    </div>
  );
};

export default FloatingContact;
